import ComponentManager from '@/Management/ComponentManager';
import MultiSelectDropDownListViewModel from '@/ViewModels/Controls/MultiSelectDropDownListViewModel';
import { ICustomDropDownItemDTO, ICustomMultiDropDown } from '#/DefaultViewExtensionInterfaces';
import CustomDropDownHelper from '@/Components/CustomDropDown/CustomDropDownHelper';

export default class CustomMultiDropDownViewModel extends MultiSelectDropDownListViewModel implements ICustomMultiDropDown {
    private dropDownHelper: CustomDropDownHelper<this>;

    public values: KnockoutComputed<string[]>;
    public data: KnockoutComputed<ICustomDropDownItemDTO[]>;
    
    constructor(protected readonly params: any) {
        super($.extend(params,
            {
                dataValueField: 'Identifier',
                dataTextField: 'DisplayName'
            }
        ));

        this.createHelperIfNeccessary();
    }

    /**
     * Creates helper if neccessary
     */
    private createHelperIfNeccessary() {
        if (this.dropDownHelper == null)
            this.dropDownHelper = new CustomDropDownHelper(this, this.params.dto);
    }

    /**
     * Safe access to helper (from parent constructor)
     */
    private getHelper(): CustomDropDownHelper<this> {
        this.createHelperIfNeccessary();
        return this.dropDownHelper;
    }

    /**
     * @override 
     */
    protected createData(): KnockoutComputed<ICustomDropDownItemDTO[]> {
        return this.getHelper().createData();
    }

    /**
     * @override 
     */
    protected createValues(): KnockoutComputed<string[]> {
        return this.getHelper().createValue<string[]>(true);
    }
    
    /**
     * @override 
     * @param added
     */
    public onAdded(added: string) {
        const values = this.values();
        values.push(added);
        this.values(values);
    }

    /**
     * @override 
     * @param removed
     */
    public onRemoved(removed: string) {
        const values = this.values();
        const idx = values.indexOf(removed);
        values.splice(idx, 1);
        this.values(values);
    }
}

ComponentManager.setViewModel('CustomMultiDropDown', CustomMultiDropDownViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');